import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Spin, Flex } from 'antd';
import styled from 'styled-components';
import { fadeIn, getSystemsError } from '../../shared';
import { userActions } from '../../store';
import { handleFetchError } from '../../helpers';

const StyledCard = styled(Card)`
  animation: ${fadeIn} .4s both ease-in-out;
`;

const Preferences = () => {
  const dispatch = useDispatch();
  const preferencesLoaded = useSelector(state =>
    state.user.preferences
    && !state.user.preferences.isLoading
    && !state.user.preferences.isError
    && state.user.preferences.data
  );

  useEffect(() => {
    dispatch(userActions.getUserPreferences()).catch((e) => handleFetchError(e, getSystemsError));
  }, [dispatch]);

  return (
    <StyledCard>
      <div data-test="preferences-empty">
        <h3>Preferences</h3>
        {!preferencesLoaded && (
          <Flex align="center" gap="middle">
            <Spin size="large" />
          </Flex>
        )}
      </div>
    </StyledCard>
  );
};

export default Preferences;
